/**
 * File blog-search.js.
 * Track queries made using the blog search
 */

const search = document.querySelectorAll('.searchform');

function trackSearchSubmit(term, location, callback) {
  let properties = {
    search_term: term,
    search_location: location
  };

  segment(
    'track',
    'Blog Search Submitted',
    properties,
    callback
  );

  // Analytics SDK firing
  fireAnalyticsEvent(Track.WebFormSubmitted, {
    unique_id: 'blog_search_submitted',
    fields: [
      { field_name: "search_term", field_value: term },
      { field_name: "search_location", field_value: location },
    ],
  });
}

// Inits
for (i = 0; i < search.length; i++) {
  const thisSearch = search[i];
  const location = thisSearch.classList.contains('searchform--header') ? 'header' : 'body';
  const form = thisSearch.querySelector('form');

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    const input = form.querySelector('.searchform__input').value;
    const callbackUrl = '/?s=' + encodeURIComponent(input);
    const goToUrl = redirect(callbackUrl);

    trackSearchSubmit(input, location, goToUrl);
  });
}